/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * The DID Document representation.
 */
export interface DidDocument {
    /** List of the contexts of the DID document. */
    context: string[];
    /** The assertion method of the DID document. */
    assertionMethod: string[];
    /** The authentication method of the DID document. */
    authentication: string[];
    /** The DID of the DID document. */
    id: string;
    /** The service of the DID document. */
    service: Truvity.Service[];
    /** The verification method of the DID document. */
    verificationMethod: Truvity.DidDocumentVerificationMethodItem[];
}
